// extracted by mini-css-extract-plugin
export default {"container":"GenerateImage_container__tmPOo","wrapper":"GenerateImage_wrapper__z6W+o","image":"GenerateImage_image__iKJ7n","inputWrapper":"GenerateImage_inputWrapper__5cou9"};